module.exports = __webpack_public_path__ + "static/media/contact.938f0cdb.jpg";